import React from "react";
import "./sign-request-by-volume-resume.view.css";
import { useTranslation } from "react-i18next";
import { ButtonHLPure } from "../../pures";
import { Label } from "@progress/kendo-react-labels";
import { Grid } from "@material-ui/core";
import { DialogSystemGLPure } from "../../pures";

const SignRequestByVolumeResume = (props) => {
  const { t } = useTranslation();
  const {
    step,
    onHandleBack,
    onSendToSign,
    requestName,
    comments,
    description,
    csvJson,
    limitDate,
  } = props;
  const { send, back } = step;

  const formatDate = (date) => {
    let day = date.getDate();
    let month = date.toLocaleString("default", { month: "short" });
    let year = date.getFullYear();

    if (month < 10) {
      return `${day}/0${month}/${year}`;
    } else {
      return `${day}/${month}/${year}`;
    }
  };

  const limitDateFormatted = formatDate(limitDate);

  return (
    <div className="card-description-reliable">
      <Grid lg={12} md={12} style={{ width: "100%" }}>
        <Grid container lg={12} md={12} es={12} direction="column">
          {" "}
          <Label className="label-title-name-request">
            {t("signRequestByVolume.requestName")}:{" "}
            <span className="value-name">{requestName}</span>
          </Label>
          {/* <Label className="label-title">
            {t("signRequestByVolume.summaryDocument")}:{" "}
            <span className="value-resume">{description}</span>
          </Label> */}
          <Label className="label-title">
            {t("signRequestByVolume.notesForSigners")}:{" "}
            <span className="value-notes">{comments}</span>
          </Label>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <hr className="line-section" />
          </Grid>
        </Grid>
        <Grid container lg={12} md={12} es={12} direction="column">
          <Label className="label-middle-title">
            {t("signRequestByVolume.amountOfDocuments")}:{" "}
            <span className="value-documents">{csvJson.length} {t("signRequestByVolumeResume.documents")}</span>
          </Label>
        </Grid>
        <Grid container lg={12} md={12} es={12} direction="column">
          <Label className="label-title">
            {t("signRequestByVolume.finalDateForSigns")}:{" "}
            <span className="value-date">{limitDateFormatted}</span>
          </Label>
          <Label className="label-title-services">
            {t("signRequestByVolume.pscServices")}:
            {props.serviceSTChecked && (
              <span className="value-serviceStamp">
                {t("signRequestByVolume.serviceTimeStamp")}
              </span>
            )}
            {props.serviceCMChecked && props.serviceSTChecked && (
              <p className="value-y"> y </p>
            )}
            {props.serviceCMChecked && (
              <span
                className={`value-serviceConservation-${
                  props.serviceCMChecked && props.serviceSTChecked
                    ? "both"
                    : "alone"
                }`}
              >
                {t("signRequestByVolume.serviceConservation")}
              </span>
            )}
            {!props.serviceCMChecked && !props.serviceSTChecked && (
              <span className="value-ninguno">{t("signRequestByVolumeResume.nothing")}</span>
            )}
          </Label>

          {props.signatureTypeESignChecked && (
            <Label className="label-title">
              {t("signRequestByVolume.signType")}:{" "}
              <span className="value-signType">
                {" "}
                {t("signRequestByVolume.eSign")}
              </span>
            </Label>
          )}
          {props.signatureTypeAdvancedChecked && (
            <Label className="label-title">
              {t("signRequestByVolume.signType")}:{" "}
              <span className="value-signType">
                {" "}
                {t("signRequestByVolume.advanced")}
              </span>
            </Label>
          )}
          {props.signatureTypeAutographChecked && (
            <Label className="label-title">
              {t("signRequestByVolume.signType")}:{" "}
              <span className="value-signType">
                {t("signRequestByVolume.autograph")}
              </span>
            </Label>
          )}
          <Label className="label-title">
            {t("signRequestByVolume.signFlow")}:{" "}
            {props.processTypeRandomChecked && (
              <span className="value-processType">
                {t("signRequestByVolume.random")}
              </span>
            )}
            {props.processTypeSequentialChecked && (
              <span className="value-processType">
                {t("signRequestByVolume.sequential")}
              </span>
            )}
            {props.processTypeAprovationChecked && (
              <span className="value-processType">
                {t("signRequestByVolume.approbation")}
              </span>
            )}
            {props.processTypeAprovationSequentialChecked && (
              <span className="value-processType">
                {t("signRequestByVolume.sequentialApprobation")}
              </span>
            )}
          </Label>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <hr className="line-section" />
          </Grid>        
        </Grid>
      </Grid>

      <div className="signRequestByVolumeResume-container-btns">
        <ButtonHLPure
          nameBtn={back}
          primary={false}
          onClickBtn={(event) => onHandleBack(event)}
        />
        <ButtonHLPure
          nameBtn={send}
          primary={true}
          onClickBtn={() => {
            onSendToSign();
          }}
        />
      </div>
      <DialogSystemGLPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
        toggleErrorDomain={props.toggleErrorDomain}
        cancel={props.cancel}
        handleSubmitConfirm={props.handleSubmitConfirm}
      />
    </div>
  );
};

export default SignRequestByVolumeResume;
